import { useMemo } from 'react';

import type { FilterConfig } from '../../../interfaces/filterConfig';

const FILTER_NOT_IN_MAP = 2;

export const useFilterCount = (filterConfigs: FilterConfig[]): number =>
  useMemo(
    () =>
      filterConfigs?.filter(
        (filter) =>
          filter.type === 'range' ||
          filter.type === 'color' ||
          (filter.type === 'checkbox' &&
            filter.attributeName === 'categories.last') ||
          filter.type === 'checkbox' ||
          filter.type === 'custom',
      ).length || 0 + FILTER_NOT_IN_MAP,
    [filterConfigs],
  );
